import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  Grid,
  IconButton,
} from '@mui/material'
import React, { useContext, useMemo } from 'react'

import FileUploader from '../../../../components/FileUploader'
import PrimeTable from '../../../../components/PrimeTable'
import dayjs from 'dayjs'
import { BsEyeFill } from 'react-icons/bs'
import { metodoPrograma } from '../../../../components/api'
import ModalDocumento from './ModalDocumento'
import { useModal } from '../../../../components/Utils/UseModal'
import { GlobalContext } from '../../../../App'
import { setInfo } from '../../../../components/alerts'

const ModalAnexaComprovante = ({ data: { idPedidoVenda }, close }) => {
  const openModalDoc = useModal(ModalDocumento)
  const { usuarioLogado } = useContext(GlobalContext)
  const parametrosTabela = useMemo(
    () => ({ idPedidoVenda, idUsuario: usuarioLogado.id }),
    [idPedidoVenda, usuarioLogado.id],
  )

  const [refresh, setRefresh] = React.useState(false)

  const head = ['Documento', 'Usuario', 'Dt. Inclusao', '']

  const line = (item) => [
    item?.[3],
    item?.[2]?.[1],
    item?.[1] ? dayjs(item?.[1]).format('DD/MM/YYYY HH:mm') : '',
    '',
  ]

  const anexarDocumento = async (v) => {
    const documento = v?.documento[0]

    const payload = {
      idDocumento: documento?.idDocumento,
      idPedidoVenda,
    }

    await metodoPrograma('anexaComprovantes', payload)
    setRefresh((v) => !v)
  }
  const handleFalse = () => close(false)

  const abreDocumento = (linha) => async () => {
    if (!linha?.[4])
      return setInfo('Documento não encontrado ou sem permissão de acesso')

    await openModalDoc({ token: linha?.[4] })
  }

  return (
    <Dialog maxWidth="lg" fullWidth open={true} onClose={handleFalse}>
      <DialogTitle>Anexar Comprovante</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PrimeTable
              lineStyle={{ textOverflow: 'ellipsis' }}
              disablePagination
              action="listaComprovantes"
              codigo="CtrlPontoVenda"
              parametros={parametrosTabela}
              refresh={refresh}
              collumnsDateHour={[4]}
              collumnsCurrency={[6]}
              columnOptions={[
                {
                  alias: 3,
                  customJsx: ({ linhaOriginal }) => (
                    <IconButton
                      size="small"
                      onClick={abreDocumento(linhaOriginal)}
                    >
                      <BsEyeFill />
                    </IconButton>
                  ),
                },
              ]}
              head={head}
              line={line}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid item xs={12} spacing={2} container justifyContent="flex-end">
          <Grid item xs={6}>
            <FileUploader
              path="/proposta/"
              snPublico="N"
              onUploadComplete={anexarDocumento}
            />
          </Grid>
          <Grid item xs={6}>
            <Button
              fullWidth
              onClick={() => close(false)}
              variant="contained"
              color="secondary"
            >
              Fechar
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  )
}

export default ModalAnexaComprovante
